import styled from 'styled-components';

export const RnRPopupOverlay = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 999;
  overflow-y: scroll;
`;
export const RnRPopupWrap = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  width: 100%;
  background: white;
  border-radius: 0.4rem;
  position: absolute;
  top: 5rem;
`;
export const RnRPopup = styled.section`
  padding: 2rem 10rem 5rem;
  display: flex;
  flex-direction: row;
`;
export const RnRLeftContent = styled.section`
  width: 30%;
  padding-right: 3rem;
  padding-top: 1.5rem;
`;
export const RnRRightContent = styled.section`
  width: 70%;
  padding-left: 5rem;
`;

export const NameRating = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const UserName = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const Avatar = styled.div`
  width: 2.7rem;
  height: 2.7rem;
  border-radius: 50%;
  background: #d8d8d8;
  margin-right: 1rem;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const NameTxt = styled.span`
  font-size: 1.4rem;
`;
export const ReviewBlock = styled.div`
  padding-bottom: 2rem;
  border-bottom: 1px solid #e5e5e5;
`;
export const ReviewContent = styled.div`
  padding: 1rem 0;
  display: flex;
  flexwrap: wrap;
  font-size: 1.2rem;
  line-height: 1.2;
  color: black;
`;
export const LikeContent = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 1.2rem;
  padding: 1rem 0;
  .likeTxt {
    color: #18a160;
  }
  .keyTxt {
    color: #647a97;
  }
`;
export const OperatorRespBlock = styled.aside`
  padding-top: 1rem;
`;
export const OpLink = styled.a`
  font-size: 1.2rem;
  color: #2276e3;
`;
export const OpRespBlock = styled.div`
  border-radius: 0.4rem;
  background: #eff3f8;
  padding: 1rem;
  width: 100%;
  p {
    font-size: 1.2rem;
    color: #777;
    padding: 0.3rem 0;
  }
`;
export const ReviewDate = styled.span`
  color: #777;
  font-size: 1.2rem;
  padding-left: 1rem;
`;
export const RatingWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
export const FilterBlock = styled.section`
  border-radius: 0.4rem;
  border: solid 1px #eff3f8;
  background: white;
  padding: 1.5rem;
  margin-top: 2rem;
`;
export const FilterList = styled.div`
  padding: 1.5rem 0 1rem;
  div {
    padding-bottom: 1rem;
  }
`;
export const CloseButton = styled.div`
  display: flex;
  justify-content: flex-end;
  font-size: 1.5rem;
  color: #2276e3;
  flex-direction: row;
  padding: 2rem 3rem;
  cursor: pointer;
`;
export const FilterHeader = styled.h3(
  props => `
    color: #141823;
    font-size: 1.4rem;
    font-weight: bold;
    font-family:${props.theme.font.fontFamily};
    `,
);
export const RatingRangeWrap = styled.div`
  border-radius: 0.4rem;
  border: solid 1px #eff3f8;
`;
export const ReviewBlockWrap = styled.div`
  border-bottom: 1px solid #e5e5e5;
`;
